import { render } from "./anc_profile.vue?vue&type=template&id=75d20696&scoped=true"
import script from "./anc_profile.vue?vue&type=script&lang=js"
export * from "./anc_profile.vue?vue&type=script&lang=js"

import "./anc_profile.vue?vue&type=style&index=0&id=75d20696&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d20696"]])

export default __exports__